import axiosInstance from "../utils/axios";

// const getS3UploadUrl = async (fileName: string, contentType: string) => {
// 	const response = await axiosInstance.get('/get-upload-url', { params: { fileName, contentType } });
// 	return response.data;
// };

const getS3DownloadUrl = async (fileName: string) => {
	const response = await axiosInstance.get('/get-download-url', { params: { fileName } });
	return response.data;
};

// const deleteFile = async (fileName: string) => {
// 	const response = await axiosInstance.delete('/delete-s3-file', { params: { fileName } });
// 	return response.data;
// }

const s3Service = {
	// getS3UploadUrl,
	getS3DownloadUrl,
	// deleteFile
};

export default s3Service;
